import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the window to the top whenever the route pathname changes.
 *
 * Mounted once inside <BrowserRouter>. React Router does not reset scroll
 * by default — without this, navigating between pages preserves the previous
 * page's scroll position, which feels broken on apps with long pages.
 *
 * Live-stream / chat / hash routes opt out so deep-link anchors and in-page
 * scroll behaviour aren't trampled.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL carries a #hash, let the browser handle anchor scroll.
    if (hash) return;
    // Defer one frame so the new route renders before we scroll — avoids
    // a flash of "still at the bottom" on slow paint.
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  }, [pathname, hash]);

  return null;
}
